var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Property-Card-/-Special","transform":"translate(-24.000000, -160.000000)","fill":"#0D7377"},React.createElement("g",{"id":"Group-2-Copy-2","transform":"translate(16.000000, 154.000000)"},React.createElement("g",{"id":"chevron_left-24px"},React.createElement("polygon",{"id":"Path","points":"15.41 7.41 14 6 8 12 14 18 15.41 16.59 10.83 12"})))))]);
}

Arrow.defaultProps = {"width":"8px","height":"12px","viewBox":"0 0 8 12","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
